module.exports = __webpack_public_path__ + "static/media/Madfit-13.4378b457.jpg";